<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-default" >
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">お知らせ
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <b-tabs content-class="mt-3" justified>
          <b-tab title="ALL" active @click="getNews(1, 'ALL')"></b-tab>
          <b-tab title="EVENT" @click="getNews(1, 'Event')"></b-tab>
          <b-tab title="BOOK" @click="getNews(1, 'Book')"></b-tab>
          <b-tab title="STORE" @click="getNews(1, 'Store')"></b-tab>
          <b-tab title="OTHER" @click="getNews(1, 'Other')"></b-tab>
        </b-tabs>
        <b-table :items="News.items"
                 :fields="NewsTableFields"
                 thead-class="d-none">
          <template #cell(Title)="row">
            <a href="#" @click.prevent="row.toggleDetails"><u>{{ row.value }}</u></a>
          </template>
          <template #cell(Tags)="row">
            <badge pill :type="row.item.badgeType">{{ row.value }}</badge>
          </template>
          <template #row-details="row">
            <b-card>
              <div v-html="row.item.Body"></div>
            </b-card>
          </template>
        </b-table>
        <div>
          <b-pagination-nav :value="News.currentPage" :link-gen="linkGen" :number-of-pages="this.News.pageCount" @change="getNews" align="center"></b-pagination-nav>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import 'moment/locale/ja'
import moment from "moment";

export default {
  name: "books",
  components: {
    moment
  },
  data() {
    return{
      News: {
        items: [],
        parPage: 5,
        currentPage: 1,
        pageCount: 1,
        totalRows: 1,
        tags: 'ALL'
      },
      NewsTableFields: ['StringCreatedAt', 'Tags', 'Title']
    };
  },
  head: {
    meta: function () {
      return [
        { property: 'og:title', content: '雛菊書房 - お知らせ' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」の新着情報です' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    }
  },
  created() {
    moment.locale('ja')
    if (typeof this.$route.query.page != 'undefined' && this.$route.query.page > 0) {
      this.News.currentPage = this.$route.query.page;
    }
    this.getNews(this.News.currentPage)
  },
  methods: {
    getNews(page = 1, tags = this.News.tags) {
      let tags_params = ''
      if(tags != 'ALL') {
        tags_params = '&filters[Tags][$eq]=' + tags
      }
      if(tags != this.News.tags){
        this.News.tags = tags
      }
      this.axios.get('strapi/api/announces?sort[0]=publishedAt%3Adesc' + tags_params + '&pagination[page]=' + page + '&pagination[pageSize]=5')
        .then(response =>{
          this.News.items = response.data.data
          this.News.parPage = response.data.meta.pagination.pageSize
          this.News.currentPage = response.data.meta.pagination.page
          this.News.pageCount = response.data.meta.pagination.pageCount
          this.News.totalRows = response.data.meta.pagination.total
          response.data.data.forEach(function (value, index, array){
            array[index] = value['attributes']
            if(value['attributes']['CustomPublishDateTime'] == true) {
              array[index]['ViewCreatedAt'] = value['attributes']['CustomCreateAt']
              if(!value['attributes']['CustomUpdateAt']){
                array[index]['ViewUpdatedAt'] = value['attributes']['CustomCreateAt']
              } else {
                array[index]['ViewUpdatedAt'] = value['attributes']['CustomUpdateAt']
              }
            } else {
              array[index]['ViewCreatedAt'] = value['attributes']['publishedAt']
              array[index]['ViewUpdatedAt'] = value['attributes']['updatedAt']
            }
            array[index]['StringCreatedAt'] = moment(array[index]['ViewCreatedAt']).format('lll')
            array[index]['StringUpdatedAt'] = moment(array[index]['ViewUpdatedAt']).format('lll')
            switch (value['attributes']['Tags']){
              case "Event":
                array[index]['badgeType'] = 'danger';
                break;
              case "Book":
                array[index]['badgeType'] = 'primary>';
                break;
              case "Store":
                array[index]['badgeType'] = 'warning';
                break;
              case "Blog":
                array[index]['badgeType'] = 'info';
                break;
              case "Other":
                array[index]['badgeType'] = 'success';
                break;
              default:
                array[index]['badgeType'] = 'default';
                break;
            }
          }, this)
          this.News.items.sort(function (a, b){
            return (a.ViewCreatedAt > b.ViewCreatedAt) ? -1 : 1;
          })
        }).catch(error =>{
          console.log(error)
      })
    },
    linkGen(pageNum) {
      let queryParam = {}
      if (pageNum > 1) {
        queryParam = { page: pageNum }
      }
      return {
        name: 'news',
        query: queryParam,
      }
    },
  }
};
</script>
<style>
</style>
